import React, { useState, useEffect } from "react";
import { Auth } from "../../../Common/lib/auth";

export default function EmailStep({ userInfo, setUserInfo, currentStep, setCurrentStep, classNames }) {
  const [errors, setErrors] = useState({
    emailError: "",
  });

  useEffect(() => {
    setErrors(prevState => ({
      ...prevState,
      emailError: "",
    }));
  }, [userInfo]);

  /**
   * Initiates a forgot password request and sends the user a code to their email if the user exists
   */
  async function sendResetCode() {
    try {
      await Auth.forgotPassword(userInfo.email);
      setCurrentStep(currentStep + 1)
    }
    catch (error) {
      // console.log(error);
      setErrors((prevState) => ({
        ...prevState,
        emailError: "User does not exist",
      }));
    }
  }

  /**
   * Handles input field changes.
   * @param {*} field Name of userInfo property to change
   * @param {*} value Value from input field
   */
  function handleChange(field, value) {
    setUserInfo((prevState) => ({
      ...prevState,
      [field]: value.trim(),
    }));
  }

  return (
    <>
      <div className="mb-6 sm:col-span-2">
        <label htmlFor="first-name" className="items-center flex text-sm sm:text-base font-medium text-gray-700 dark:text-white">
          Email
          {errors.emailError.length > 0 &&
            <p className="italic text-xs sm:text-sm block font-base font-normal text-red-600 dark:text-red-500">
              &nbsp;- {errors.emailError}
            </p>
          }
        </label>
        <div className="mt-1">
          <input
            onChange={(e) => handleChange("email", e.target.value)}
            defaultValue={userInfo.email}
            type="email"
            name="email"
            id="email"
            className={classNames(errors.emailError.length > 0 ? 'border-red-600 dark:border-red-500' : 'border-gray-300 dark:border-gray-600', 'border outline-none focus:ring-1 text-sm sm:text-base py-3 px-4 block w-full shadow-sm focus:ring-blue-500 focus:border-blue-500 rounded-md dark:bg-gray-700 dark:text-white')}
          />
        </div>
      </div>

      <div className="text-sm sm:text-base gap-14 sm:gap-24 flex justify-between">
        <button
          onClick={() => sendResetCode()}
          type="button"
          className="rounded-md w-full bg-blue-600 py-2.5 px-3.5 text-md font-semibold text-white shadow-sm hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        >
          Continue
        </button>
      </div>
    </>
  )
}